
import Cardinality1 from '@img/Cardinalite_n_1.png';
import Cardinality2 from '@img/Cardinalite_1_n.png';
import Cardinality3 from '@img/Cardinalite_n_n.png';
import Cardinality4 from '@img/Cardinalite_1_1.png';
// import Image from 'next/image';
import { TW_AppBlogArticle, TW_AppblogArticleIcons, TW_AppBlogParagraphMargin } from '@utils/twClasses';

export default function Page() {

    return (
        <div className={TW_AppBlogArticle}>
            <h1 className="mb-6 text-3xl font-semibold text-black">
                The different types of fields
            </h1>
            <p className={TW_AppBlogParagraphMargin}>
                Now that you have created your first data model and your objects, you will be able to create different types of fields for each object according to your needs:
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                The "Text" fields
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                You can enter any information you want in this field, whether textual or numeric. However, if you use it to store numbers or dates, for example, you will not benefit from the advantages of typed fields for storing this type of data.
            </p>
            <div className={TW_AppBlogParagraphMargin}>
                Fields can be formatted in different ways:
                <ul className="list-disc list-inside">
                    <li>No formatting</li>
                    <li>ALL UPPERCASE</li>
                    <li>all lowercase</li>
                    <li>Or The First Letter Of Each Word In Uppercase</li>
                </ul>
                {/* <p>If formatting is removed, the data returns to its original form as the user entered it.</p> */}
            </div>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                The "Multiline text" fields
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                This field allows you to enter textual information on multiple lines. Unlike the "Text" field which displays text linearly, the user can see the text on multiple lines and organize it as they wish.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Depending on the field you choose, the text will be displayed differently:
            </p>
            <p className={TW_AppBlogParagraphMargin}> <strong>"Text" field:</strong> <br></br>24/09/2025 Appointment with Mr. Dupont from company XXX. Reason: Assessment of IT equipment needs.
            </p>
            <p className={TW_AppBlogParagraphMargin}> <strong>"Multiline text" field:</strong> <br></br> 24/09/2025<br></br> Appointment with Mr. Dupont from company XXX.<br></br> Reason: Assessment of IT equipment needs.
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                The "Integer" fields
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Fill this field with whole numbers. You can define how numbers are displayed (thousands separator).
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Example :<br></br> Product stock quantity: 1,400,000 or 1,400,000 or 1.400.000
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                The "Decimal" fields
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Fill this field with decimal numbers. You can define how numbers are displayed (thousands separator, decimal separator, number of decimals).
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Example :<br></br>  Invoice amount: 3,507.6 or 3,507.57 or 3.507,570
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                The "Currency" fields
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                This field allows you to enter monetary data. You can choose the field formatting, the number of decimals, and the symbol (€, $, USD,…).
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Example :<br></br>  Product price: 1,250.00 €, $ 1,250 or € 1,250.00
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                The "Checkbox" fields
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                This field is a simple checkbox. In views, you can filter data according to whether the box is checked or not.
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                The "Date" fields
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                This field allows you to enter a date. You can choose the date format from a list of predefined formats.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Example :<br></br>  Billing date: 14/05/2025, May 14, 2025, Wednesday, May 14, 2025, 14
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                The "Period" fields
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Use this field to define a period. Unlike the date field which allows you to define a day, the Period field allows you to choose a week, a month, a quarter, or even a year.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Example :<br></br>  VAT declaration: February 2025, Q1 2025
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                The "Choice" fields
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Define as many options as you want. When editing a "Choice" field, you can only choose one value.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Example :<br></br>  Contact type: "Client", "Prospect" or "Supplier"
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                The "Multiple choice" fields
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Same principle as the "Choice" field, except that when editing the field, you can select multiple values for this field.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Example :<br></br>  Product characteristics: "Armchair", "Vintage" and "Blue"
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                The "User" fields
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                This field allows you to select a user from Compozz users
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Example :<br></br> Created by: Nathan Mercier
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                The "Percentage" fields
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Use this field to enter percentages. Like decimal fields, you can choose the field formatting.
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                The "URL" fields
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                This field allows you to enter a clickable URL link. You can choose the field formatting like for a "Text" field<div className=""></div>
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                A little tip if you want your link to appear under a name rather than the URL itself, you can do this by entering the generic name followed by an "@", followed by the URL (name@url):
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                "Compozz@https://compozz.com/" will appear as "Compozz" in your field and will take you to the page https://compozz.com/ when you click on it.
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                The "Link to another object" fields
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                This field deserves a little more attention than the others. As you now know, your data models are based on the creation of objects. And the whole interest of Compozz is to be able to link these objects to aggregate data as you want and highlight the important data for your company.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                This field will allow you to link your objects. First, choose the field of the object you want to link.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Once you have selected the field you want to link, 3 pieces of information must be filled in:
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                <strong>Relation name:</strong> By default, it takes the name of the object you want to link; you can modify it if needed. Naming the relation will be useful if you want to link other fields of this same object: by reusing it, you will automatically apply the relation parameters to your new field. But you can also have two different relations that link the same objects.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Object 1 = Projects<br></br> Object 2 = Collaborators
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                We create a "Project Manager" field in the Project object. In this case, only one Collaborator will be assigned to the project as Project Manager.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                We create a "Team members" field in the Project object. In this case, several Collaborators can be assigned to the project as Team members.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                <strong>Cardinality:</strong> Allows you to define more precisely the link that unites the two objects.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Pictograms help you make your choice. Let's see together how to read them.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                The object you are currently on (Object 1) is represented on the left of the pictogram. The one you want to link (Object 2) is represented on the right of the pictogram:
            </p>
            <div className='flex flew-row gap-3 mb-5 '>
                <img 
                    className={TW_AppblogArticleIcons} 
                    src={Cardinality1} 
                    alt="Cardinality_many_to_one" 
                />
                <p className='content-center'>
                    You can assign the same Object 2 to several Object 1. An Object 1 can only have one Object 2.
                </p>
            </div>
            <div className='ml-5'>
                <p className={TW_AppBlogParagraphMargin}>
                    Example :<br></br>Object 1 = Projects<br></br>Object 2 = Collaborators
                </p>
                <p className={TW_AppBlogParagraphMargin}>
                    We create a Link field on the Projects object. This field will be used to assign a Project Manager to the Project. A project manager can manage several projects, but a project is managed by only one project manager.
                </p>
                <p className={TW_AppBlogParagraphMargin}>
                    Project A will have Collaborator B as Project Manager<br></br>Project B will have Collaborator B as Project Manager<br></br>Project C will have Collaborator A as Project Manager
                </p>
            </div>
            <div className='flex gap-3 align-center mb-5'>
                <img 
                    className={TW_AppblogArticleIcons} 
                    src={Cardinality2} 
                    alt="Cardinality_one_to_many" 
                />
                <p className='content-center'>
                    Several Object 2 can be assigned to the same Object 1. An Object 2 can only have one Object 1
                </p>
            </div>
            <div className='ml-5'>
                <p className={TW_AppBlogParagraphMargin}>
                    Example :<br></br>Object 1 = Managers<br></br>Object 2 = Collaborators
                </p>
                <p className={TW_AppBlogParagraphMargin}>
                    We create a Link field on the Managers object. This field will be used to assign collaborators to the Manager. A manager "manages" several collaborators, but a collaborator has only one (direct) manager.
                </p>
                <p className={TW_AppBlogParagraphMargin}>
                    Manager A will have Collaborator A and Collaborator B in their team<br></br>Manager B will have Collaborator C in their team<br></br>Collaborators A, B, and C cannot be assigned to another Manager
                </p>
            </div>
            <div className='flex gap-3 align-center mb-5'>
                <img 
                    className={TW_AppblogArticleIcons} 
                    src={Cardinality3} 
                    alt="Cardinality_many_to_many"
                />

                <p className='content-center'>
                    Several Object 1 can have several Object 2.
                </p>
            </div>
            <div className='ml-5'>
                <p className={TW_AppBlogParagraphMargin}>
                    Example :<br></br>Object 1 = Products<br></br>Object 2 = Characteristics
                </p>
                <p className={TW_AppBlogParagraphMargin}>
                    We create a Link field on the Products object. This field will be used to assign characteristics to each Product. A product can have several characteristics (color, type, size…) and the same characteristic can be assigned to several different products.
                </p>
                <p className={TW_AppBlogParagraphMargin}>
                    Product A will have Characteristic A, B, and C<br></br>Product B will have Characteristic B and C<br></br>Product C will have Characteristic A, B, and C
                </p>
            </div>
            <div className='flex gap-3 align-center mb-5'>
                <img 
                    className={TW_AppblogArticleIcons} 
                    src={Cardinality4} 
                    alt="Cardinality_one_to_one" 
                />
                <p className='content-center'>
                    An Object 2 can only be assigned to one Object 1, and an Object 1 can only have one Object 2.
                </p>
            </div>
            <div className='ml-5'>
                <p className={TW_AppBlogParagraphMargin}>
                    Example :<br></br>Object 1 = Departments<br></br>Object 2 = Department Managers
                </p>

                <p className={TW_AppBlogParagraphMargin}>
                    Department A will have Department Manager B <br></br>Department B will have Department Manager A<br></br>Department Managers A and B cannot be assigned to other Departments
                </p>
            </div>
            <p className={TW_AppBlogParagraphMargin}>
                <strong>Aggregation:</strong> Allows you to define how the data will be displayed. Let's see the different possibilities in more detail with the following example:
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                We create a link between a "Collaborators" object and a "Projects" object from the "Projects" object. We decide to display the first names of the collaborators.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                We assign the following collaborators to Project A: Thibaut Rousseau, Léna Piton, Valérie Ledru, and Thibaut Bordet.
            </p>
            <ul className="list-disc list-inside mb-5">
                <li className="mb-2">Concatenation<br></br> Project A will be presented in a single line, and in the "Collaborators" field we will have the following information: "Thibaut", "Léna", "Valérie", and "Thibaut".</li>
                <li className="mb-2">Value<br></br> Project A will be presented in several lines, namely one line for each value. Note here, we might think that in our case we would have 4 lines, one for each collaborator. In fact, we only have 3, because we have the value "Thibaut" twice in our Collaborators field. So:
                    <ul className="list-none list-inside ml-5 mt-2">
                        <li>Line 1: Project A / "Thibaut"</li>
                        <li>Line 2: Project A / "Léna"</li>
                        <li>Line 3: Project A / "Valérie"</li>
                    </ul>
                </li>
                <li className="mb-2">Count<br></br> Project A will be presented in a single line, and we will have in the "Collaborators" field the number of collaborators assigned to the project. In our case, this will be "4".</li>
                <li className="mb-2">Count distinct<br></br> Like "Count", Project A will be presented in a single line, but a repeated value is counted only once: we will have in the "Collaborators" field the number of different first names. In our case, this will be "3", since "Thibaut" appears twice.</li>
                <li className="mb-2">No aggregation<br></br> Project A will be presented in 4 lines, one for each collaborator. We will therefore have:
                    <ul className="list-none list-inside ml-5 mt-2">
                        <li>Line 1: Project A / "Thibaut"</li>
                        <li>Line 2: Project A / "Léna"</li>
                        <li>Line 3: Project A / "Valérie"</li>
                        <li>Line 4: Project A / "Thibaut"</li>
                    </ul>
                </li>
            </ul>
            <p className={TW_AppBlogParagraphMargin}>
                We have covered all the types of fields you can use in Compozz. If you need additional information, don't hesitate to <a href="/freeTrial" className="text-compozz-darker-purple hover:underline">contact us</a>!
            </p>
        </div>
    )

}
